import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  setErrorAlert,
  setLoader,
  setSuccessAlert,
  clearAlerts,
} from "../alert/alertSlice";
import { uploadImage } from "../../utils/upload";
import axios from "../../utils/axios";
import { clearUser, setEmail, setPhone } from "../user/userSlice";
import { postDataAPI } from "../../utils/fetchData";
import { clearAddSection } from "../addsection/addsectionSlice";
import { clearAuth, optClear } from "./authSlice";
import autoPopulationService from "../../services/autoPopulationService";
import { smoothNavigate } from "../../utils/smoothNavigation";
// import { setErrorAlert, setLoader, setSuccessAlert } from "../alert/alertSlice";

export const add_userInfo_thunk = createAsyncThunk(
  "/auth/add_user_info",
  async (tempData, thunkAPI) => {
    try {
      thunkAPI.dispatch(setLoader(true));
      if (
        typeof tempData?.avatar === "string" &&
        tempData?.avatar?.includes("https://")
      ) {
        tempData.avatar = tempData.avatar;
      } else if (tempData?.avatar instanceof File) {
        let avatar = await uploadImage(tempData.avatar);
        if (!avatar) {
          thunkAPI?.dispatch(
            setErrorAlert("Image cannot contain nudity , violence or drugs")
          );
          return false;
        }
        if (avatar) tempData.avatar = avatar;
      } else {
        console.error("Invalid avatar data");
      }
      const response = await axios.post("auth/add_user_info", tempData, {});
      localStorage.setItem(
        "dizeeUser",
        JSON.stringify(response.data.data.user)
      );
      localStorage.setItem(
        "dizeeToken",
        JSON.stringify(response.data.data.token)
      );
      // Set flag for new signup to trigger tutorial
      localStorage.setItem("isNewSignup", "true");
      
      // 🚀 NEW: Trigger auto-population after successful account creation
      try {
        console.log('🚀 Account created successfully, checking for auto-population...');
        const createdUser = response.data.data.user;
        
        // Only auto-populate for artists, not team members
        const isArtist = createdUser?.professionRole === 'artist' || tempData?.professionRole === 'artist';
        
        if (!isArtist) {
          console.log('ℹ️ User is not an artist (role:', createdUser?.professionRole || tempData?.professionRole, '), skipping auto-population');
        } else if (createdUser?.social?.sf || tempData?.social?.sf) {
          console.log('🎯 Artist has Spotify URL, triggering auto-population...');
          const userForPopulation = {
            ...createdUser,
            social: {
              ...createdUser?.social,
              ...tempData?.social // Include any social data from signup form
            }
          };
          
          // Trigger auto-population in background (don't wait for completion)
          autoPopulationService.autoPopulateAllApps(userForPopulation, createdUser?.name || tempData?.name)
            .then(result => {
              if (result?.success) {
                console.log('✅ Auto-population completed successfully during signup:', result);
              } else {
                console.log('⚠️ Auto-population completed but with limited success:', result);
              }
            })
            .catch(error => {
              console.error('❌ Auto-population failed during signup:', error);
              // Don't fail the signup process if auto-population fails
            });
        } else {
          console.log('ℹ️ Artist has no Spotify URL, skipping auto-population');
        }
      } catch (error) {
        console.error('❌ Error checking auto-population during signup:', error);
        // Don't fail the signup process if auto-population check fails
      }
      
      thunkAPI.dispatch(setLoader(false));
      // thunkAPI.dispatch(setSuccessAlert(response.data.message));
      return response.data;
    } catch (error) {
      console.log("error", error);
      thunkAPI.dispatch(setLoader(false));
      thunkAPI.dispatch(
        setErrorAlert(error?.response?.data?.message || "An error occurred")
      );
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || "An error occurred"
      );
    }
  }
);
export const add_personal_user_userInfo_thunk = createAsyncThunk(
  "/auth/add_user_info_personal",
  async (tempData, thunkAPI) => {
    try {
      thunkAPI.dispatch(setLoader(true));
      if (
        typeof tempData?.avatar === "string" &&
        tempData?.avatar?.includes("https://")
      ) {
        tempData.avatar = tempData.avatar;
      } else if (tempData?.avatar instanceof File) {
        let avatar = await uploadImage(tempData.avatar);
        if (!avatar) {
          thunkAPI?.dispatch(
            setErrorAlert("Image cannot contain nudity , violence or drugs")
          );
          return false;
        }
        if (avatar) tempData.avatar = avatar;
      } else {
        console.error("Invalid avatar data");
      }
      const response = await axios.post(
        "auth/add_user_info_personal",
        tempData,
        {}
      );
      localStorage.setItem(
        "dizeeUser",
        JSON.stringify(response.data.data.user)
      );
      localStorage.setItem(
        "dizeeToken",
        JSON.stringify(response.data.data.token)
      );
      // Set flag for new signup to trigger walkthrough
      localStorage.setItem("isNewSignup", "true");
      
      // 🚀 NEW: Trigger auto-population after successful account creation
      try {
        console.log('🚀 Account created successfully, checking for auto-population...');
        const createdUser = response.data.data.user;
        
        // Only auto-populate for artists, not team members
        const isArtist = createdUser?.professionRole === 'artist' || tempData?.professionRole === 'artist';
        
        if (!isArtist) {
          console.log('ℹ️ User is not an artist (role:', createdUser?.professionRole || tempData?.professionRole, '), skipping auto-population');
        } else if (createdUser?.social?.sf || tempData?.social?.sf) {
          console.log('🎯 Artist has Spotify URL, triggering auto-population...');
          const userForPopulation = {
            ...createdUser,
            social: {
              ...createdUser?.social,
              ...tempData?.social // Include any social data from signup form
            }
          };
          
          // Trigger auto-population in background (don't wait for completion)
          autoPopulationService.autoPopulateAllApps(userForPopulation, createdUser?.name || tempData?.name)
            .then(result => {
              if (result?.success) {
                console.log('✅ Auto-population completed successfully during signup:', result);
              } else {
                console.log('⚠️ Auto-population completed but with limited success:', result);
              }
            })
            .catch(error => {
              console.error('❌ Auto-population failed during signup:', error);
              // Don't fail the signup process if auto-population fails
            });
        } else {
          console.log('ℹ️ Artist has no Spotify URL, skipping auto-population');
        }
      } catch (error) {
        console.error('❌ Error checking auto-population during signup:', error);
        // Don't fail the signup process if auto-population check fails
      }
      
      thunkAPI.dispatch(setLoader(false));
      // thunkAPI.dispatch(setSuccessAlert(response.data.message));
      return response.data;
    } catch (error) {
      console.log("error", error);
      thunkAPI.dispatch(setLoader(false));
      thunkAPI.dispatch(
        setErrorAlert(error?.response?.data?.message || "An error occurred")
      );
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || "An error occurred"
      );
    }
  }
);

export const checkEmail = createAsyncThunk(
  "/auth/checkemail",
  async (email, thunkAPI) => {
    try {
      // thunkAPI.dispatch(setLoader(true));
      const res = await axios.get(`/auth/checkemail?email=${email}`);
      thunkAPI.dispatch(setLoader(false));
      if (res.data.status === 200) {
        thunkAPI.dispatch(setPhone(res?.data?.data?.phone));
        thunkAPI.dispatch(optClear(null));
        // Optionally add success alert here if needed
      }
      return res.data.data.exist;
    } catch (error) {
      // thunkAPI.dispatch(setLoader(false));
      thunkAPI.dispatch(
        setErrorAlert(error?.response?.data?.message || "An error occurred")
      );
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || "An error occurred"
      );
    }
  }
);

export const sendOtpToEmailThunk = createAsyncThunk(
  "/auth/sendOtpToEmail",
  async (email, thunkAPI) => {
    try {
      thunkAPI.dispatch(clearAlerts());
      thunkAPI.dispatch(setLoader(true));
      const res = await axios.post("/auth/sendOtpToEmail", { email });
      thunkAPI.dispatch(setLoader(false));
      if (res.data.status === 200) {
        thunkAPI.dispatch(setEmail(email));
        thunkAPI.dispatch(setSuccessAlert(res.data.message));
      }
      return res.data;
    } catch (error) {
      thunkAPI.dispatch(setLoader(false));
      thunkAPI.dispatch(setErrorAlert(error?.message || "An error occurred"));
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || "An error occurred"
      );
    }
  }
);

export const verifyEmailOTP = createAsyncThunk(
  "/auth/verifyOtpForEmail",
  async (tempData, thunkAPI) => {
    try {
      thunkAPI.dispatch(clearAlerts());
      thunkAPI.dispatch(setLoader(true));
      console.log("tempData.code", tempData.code);
      console.log("tempData.email", tempData.email);
      const res = await axios.post("/auth/verifyOtpForEmail", {
        code: tempData.code,
        email: tempData.email,
      });
      thunkAPI.dispatch(setLoader(false));
      if (res.data.status === 200) {
        thunkAPI.dispatch(setSuccessAlert(res.data.message));
      }
      return res.data;
    } catch (error) {
      thunkAPI.dispatch(setLoader(false));
      console.log("error", error);
      thunkAPI.dispatch(setErrorAlert(error?.message || "An error occurred"));
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || "An error occurred"
      );
    }
  }
);
export const verifyPhone = createAsyncThunk(
  "/auth/verifyphone",
  async (phone, thunkAPI) => {
    try {
      thunkAPI.dispatch(clearAlerts());
      thunkAPI.dispatch(setLoader(true));
      const res = await axios.post("/auth/verifyphone", { phone });
      thunkAPI.dispatch(setLoader(false));
      if (res.data.status === 200) {
        thunkAPI.dispatch(setPhone(phone));
        thunkAPI.dispatch(setSuccessAlert(res.data.message));
      }
      return res.data;
    } catch (error) {
      thunkAPI.dispatch(setLoader(false));
      thunkAPI.dispatch(setErrorAlert(error?.message || "An error occurred"));
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || "An error occurred"
      );
    }
  }
);

export const verifyOTP = createAsyncThunk(
  "/auth/verifycode",
  async (tempData, thunkAPI) => {
    try {
      thunkAPI.dispatch(clearAlerts());
      thunkAPI.dispatch(setLoader(true));
      const res = await axios.post("/auth/verifycode", {
        code: tempData.code,
        phone: tempData.phone,
      });
      thunkAPI.dispatch(setLoader(false));
      if (res.data.status === 200) {
        thunkAPI.dispatch(setSuccessAlert(res.data.message));
      }
      return res.data;
    } catch (error) {
      thunkAPI.dispatch(setLoader(false));
      console.log("error", error);
      thunkAPI.dispatch(setErrorAlert(error?.message || "An error occurred"));
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || "An error occurred"
      );
    }
  }
);

export const checkDomain = createAsyncThunk(
  "auth/checkDomain",
  async (bool, thunkAPI) => {
    try {
      return bool;
    } catch (error) {
      // thunkAPI.dispatch(setErrorAlert(error?.response?.data?.message || 'An error occurred'));
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || "An error occurred"
      );
    }
  }
);

export const checkUserName = createAsyncThunk(
  "auth/checkUserName",
  async (bool, thunkAPI) => {
    try {
      return bool;
    } catch (error) {
      // thunkAPI.dispatch(setErrorAlert(error?.response?.data?.message || 'An error occurred'));
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || "An error occurred"
      );
    }
  }
);

export const stripePaymentThunk = createAsyncThunk(
  "auth/stripePayment",
  async (tempData, thunkAPI) => {
    try {
      thunkAPI.dispatch(setLoader(true));
      let { plan, user, email, phone } = tempData;
      const response = await postDataAPI(
        "stripe/create-checkout-session",
        { plan, user, email, phone },
        {}
      );
      thunkAPI.dispatch(setLoader(false));
      window.location.href = response.data.data.url;
    } catch (error) {
      // thunkAPI.dispatch(setErrorAlert(error?.response?.data?.message || 'An error occurred'));
      thunkAPI.dispatch(setLoader(false));
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || "An error occurred"
      );
    }
  }
);

export const changePlanStripePaymentThunk = createAsyncThunk(
  "auth/stripePayment_changeplan",
  async (tempData, thunkAPI) => {
    try {
      thunkAPI.dispatch(setLoader(true));
      let { plan, token } = tempData;
      const response = await postDataAPI(
        "stripe/change_plan_checkout_session",
        { plan },
        token
      );
      thunkAPI.dispatch(setLoader(false));
      window.location.href = response.data.data.url;
    } catch (error) {
      // thunkAPI.dispatch(setErrorAlert(error?.response?.data?.message || 'An error occurred'));
      thunkAPI.dispatch(setLoader(false));
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || "An error occurred"
      );
    }
  }
);

export const loginPhoneNumberVerify = createAsyncThunk(
  "auth/loginPhoneNumberVerify",
  async (tempData, thunkAPI) => {
    try {
      thunkAPI.dispatch(setLoader(true));
      const response = await postDataAPI(
        "auth/loginPhoneNumberVerify",
        { phone: tempData.phone, email: tempData.email },
        {}
      );
      thunkAPI.dispatch(setLoader(false));
      thunkAPI.dispatch(setSuccessAlert(response.data.message));
      return response.data;
    } catch (error) {
      thunkAPI.dispatch(setLoader(false));
      thunkAPI.dispatch(
        setErrorAlert(error?.response?.data?.message || "An error occurred")
      );
      return thunkAPI.rejectWithValue(
        error?.response?.data || "An error occurred"
      );
    }
  }
);
export const loginWithOtp = createAsyncThunk(
  "auth/loginWithOtp",
  async (tempData, thunkAPI) => {
    try {
      // thunkAPI.dispatch(setLoader(true))
      const response = await postDataAPI(
        "auth/loginWithOtp",
        { phone: tempData.phone, email: tempData.email, code: tempData.code },
        {}
      );
      localStorage.setItem(
        "dizeeUser",
        JSON.stringify(response.data.data.user)
      );
      localStorage.setItem(
        "dizeeToken",
        JSON.stringify(response.data.data.token)
      );
      // Clear any signup flags since this is an existing user login
      localStorage.removeItem("isNewSignup");
      // thunkAPI.dispatch(setLoader(false))
      thunkAPI.dispatch(setSuccessAlert(response.data.message));
      
      // Load user profile data after successful login
      const { get_user_articles_thunk } = require('../user/userThunk');
      thunkAPI.dispatch(get_user_articles_thunk({ token: response.data.data.token }));
      
      return response.data;
    } catch (error) {
      thunkAPI.dispatch(setLoader(false));
      thunkAPI.dispatch(
        setErrorAlert(error?.response?.data?.message || "An error occurred")
      );
      return thunkAPI.rejectWithValue(
        error?.response?.data || "An error occurred"
      );
    }
  }
);

export const loginWithPassword = createAsyncThunk(
  "auth/loginWithPassword",
  async (tempData, thunkAPI) => {
    try {
      thunkAPI.dispatch(clearAlerts());
      thunkAPI.dispatch(setLoader(true));
      
      const response = await postDataAPI(
        "auth/login",
        { email: tempData.email, password: tempData.password },
        {}
      );
      
      localStorage.setItem(
        "dizeeUser",
        JSON.stringify(response.data.data.user)
      );
      localStorage.setItem(
        "dizeeToken",
        JSON.stringify(response.data.data.token)
      );
      
      // Clear any signup flags since this is an existing user login
      localStorage.removeItem("isNewSignup");
      // Clear any delegated access state from previous sessions
      localStorage.removeItem("selectedArtist");
      
      thunkAPI.dispatch(setLoader(false));
      thunkAPI.dispatch(setSuccessAlert(response.data.message));
      
      // Load user profile data after successful login
      const { get_user_articles_thunk } = require('../user/userThunk');
      thunkAPI.dispatch(get_user_articles_thunk({ token: response.data.data.token }));
      
      return response.data;
    } catch (error) {
      thunkAPI.dispatch(setLoader(false));
      thunkAPI.dispatch(
        setErrorAlert(error?.response?.data?.message || "An error occurred")
      );
      return thunkAPI.rejectWithValue(
        error?.response?.data || "An error occurred"
      );
    }
  }
);

export const logoutThunk = createAsyncThunk(
  "auth/logout",
  async (_, thunkAPI) => {
    try {
      // Clear Redux state first
      thunkAPI.dispatch(clearAlerts());
      thunkAPI.dispatch(clearAddSection());
      thunkAPI.dispatch(clearUser());
      thunkAPI.dispatch(clearAuth());
      
      // Use smooth navigation with storage clearing
      await smoothNavigate("/", { 
        clearStorage: true,
        fadeOutDuration: 200,
        delay: 50
      });

      return;
    } catch (error) {
      thunkAPI.dispatch(
        setErrorAlert(error?.response?.data?.message || "An error occurred")
      );
      return thunkAPI.rejectWithValue(
        error?.response?.data || "An error occurred"
      );
    }
  }
);

export const getRandomUserThunk = createAsyncThunk(
  "auth/get-random-user-list",
  async (tempData, thunkAPI) => {
    try {
      thunkAPI.dispatch(setLoader(true));
      const response = await postDataAPI(
        "auth/get-random-user-list",
        { username: tempData.username, size: tempData?.size },
        {}
      );
      thunkAPI.dispatch(setLoader(false));
      return response.data;
    } catch (error) {
      thunkAPI.dispatch(setLoader(false));
      thunkAPI.dispatch(
        setErrorAlert(error?.response?.data?.message || "An error occurred")
      );
      return thunkAPI.rejectWithValue(
        error?.response?.data || "An error occurred"
      );
    }
  }
);

export const getExploreUserThunk = createAsyncThunk(
  "auth/get-explore-user-list",
  async (tempData, thunkAPI) => {
    try {
      thunkAPI.dispatch(setLoader(true));
      const response = await postDataAPI(
        "auth/get-explore-user-list",
        { username: tempData.username, size: tempData?.size },
        {}
      );
      thunkAPI.dispatch(setLoader(false));
      return response.data;
    } catch (error) {
      thunkAPI.dispatch(setLoader(false));
      thunkAPI.dispatch(
        setErrorAlert(error?.response?.data?.message || "An error occurred")
      );
      return thunkAPI.rejectWithValue(
        error?.response?.data || "An error occurred"
      );
    }
  }
);

export const getTopUserThunk = createAsyncThunk(
  "auth/get-top-user-list",
  async (tempData, thunkAPI) => {
    try {
      thunkAPI.dispatch(setLoader(true));
      const response = await postDataAPI(
        "auth/get-top-user-list",
        { username: tempData.username, size: tempData?.size },
        {}
      );
      thunkAPI.dispatch(setLoader(false));
      return response.data;
    } catch (error) {
      thunkAPI.dispatch(setLoader(false));
      thunkAPI.dispatch(
        setErrorAlert(error?.response?.data?.message || "An error occurred")
      );
      return thunkAPI.rejectWithValue(
        error?.response?.data || "An error occurred"
      );
    }
  }
);


export const getUserFollowingListThunk = createAsyncThunk(
  "auth/get-user-following-list",
  async (tempData, thunkAPI) => {
    console.log(`get-user-following-list tempdata::`, tempData);
    try {
      thunkAPI.dispatch(setLoader(true));
      const response = await postDataAPI(
        "auth/get-user-following-list",
        { username: tempData.username, size: tempData?.size },
        {}
      );
      thunkAPI.dispatch(setLoader(false));
      return response.data;
    } catch (error) {
      thunkAPI.dispatch(setLoader(false));
      thunkAPI.dispatch(
        setErrorAlert(error?.response?.data?.message || "An error occurred")
      );
      return thunkAPI.rejectWithValue(
        error?.response?.data || "An error occurred"
      );
    }
  }
);
export const getSearchByUserDomainThunk = createAsyncThunk(
  "auth/search-user-by-domain",
  async (tempData, thunkAPI) => {
    try {
      thunkAPI.dispatch(setLoader(true));
      const response = await postDataAPI(
        "auth/search-user-by-domain",
        {
          username: tempData.username,
          domain: tempData.domain,
          size: tempData?.size,
        },
        tempData?.token
      );
      thunkAPI.dispatch(setLoader(false));
      return response.data;
    } catch (error) {
      thunkAPI.dispatch(setLoader(false));
      thunkAPI.dispatch(
        setErrorAlert(error?.response?.data?.message || "An error occurred")
      );
      return thunkAPI.rejectWithValue(
        error?.response?.data || "An error occurred"
      );
    }
  }
);

export const follow_unfollow_auth_thunk = createAsyncThunk(
  "/auth/follow-unfollow-auth-user",
  async (tempData, thunkAPI) => {
    try {
      thunkAPI.dispatch(setLoader(true));
      const response = await postDataAPI(
        "auth/follow-unfollow-auth-user",
        { username: tempData?.username, user: tempData?.user },
        null
      );
      thunkAPI.dispatch(setLoader(false));
      return response.data;
    } catch (error) {
      thunkAPI.dispatch(setLoader(false));
      thunkAPI.dispatch(
        setErrorAlert(error?.response?.data?.message || "An error occurred")
      );
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || "An error occurred"
      );
    }
  }
);
